import { MakeGenerics, Route } from '@tanstack/react-location';
import React, { lazy } from 'react';

import { AdminRouteBaseProps } from '@/layout/Admin/routes';

export type VitecPropertyLogRouteProps = MakeGenerics<{
  Params: {
    vitecPropertyLogId?: string;
  };
  LoaderData: {
    vitecPropertyLogId: string;
  };
}> &
  AdminRouteBaseProps;

const VitecPropertyLog = lazy(() => import('.'));
const View = lazy(() => import('./View'));
const Compare = lazy(() => import('./Compare'));

const VitecPropertyLogRoutes: Route<VitecPropertyLogRouteProps>[] = [
  {
    path: 'vitec',
    id: 'VitecPropertyLog',
    meta: {
      breadcrumbs: () => ({
        breadcrumb: 'Vitec',
      }),
    },
    children: [
      {
        id: 'VitecPropertyLogList',
        path: '/',
        element: <VitecPropertyLog />,
      },
      {
        path: 'compare',
        id: 'VitecPropertyLogCompare',
        element: <Compare />,
        meta: {
          breadcrumbs: () => ({
            breadcrumb: 'Jämför',
          }),
        },
      },
      {
        path: ':vitecPropertyLogId',
        id: 'VitecPropertyLogView',
        children: [
          {
            path: '/',
            element: <View />,
            loader: ({ params }) => ({
              vitecPropertyLogId: params.vitecPropertyLogId,
            }),
            meta: {
              breadcrumbs: () => ({
                breadcrumb: 'Vitec Lokaler',
              }),
            },
          },
        ],
      },
    ],
  },
];

export const toVitecPropertyLog = (): string => '/admin/vitec/';
export const toVitecPropertyLogView = (vitecPropertyLogId: string): string =>
  `/admin/vitec/${vitecPropertyLogId}`;
export const toVitecPropertyLogCompare = (): string => '/admin/vitec/compare';

export default VitecPropertyLogRoutes;
